import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {Product, RootObject} from '../../../models/product';
import {ProductService} from '../../../services/product.service';
import {ProductDataSet} from '../../../models/product-data-set';
import {SearchService} from '../../../services/search.service';
import {CustomerSearchService} from '../../../events/customer-search.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Wishlist} from '../../../models/Wishlist/Wishlist';
import {WishlistService} from '../../../services/wishlist.service';
import {RegistryService} from '../../../services/registry.service';

@Component({
    selector: 'app-products-grid',
    templateUrl: './products-grid.component.html',
    styleUrls: ['./products-grid.component.css']
})
export class ProductsGridComponent implements OnInit, AfterViewInit {
    @ViewChild('load_more_btn') load_more_btn: ElementRef;

    cats_flat = [];
    filter_categories_ids = [];
    filter_categories = [];
    manual_load = false;
    max_autoload_pages = 3;
    autoload_pages = 0;
    flag: boolean = true;
    reloadFlag: boolean = true;
    previousPage = [];
    products: Product[] = [];
    totalCount;
    page = 1;
    isLoading = false;
    selector: string = '.viewport';

    sortBy = 'newest';
    previousSortBy = 'newest';
    // wishList: Wishlist;

    @Input('ProductDataSet') ProductDataSet: ProductDataSet = null;
    @Input('isSearchGrid') isSearchGrid: boolean = false;
    @Input('searchKeyword') searchKeyword = null;

    constructor(public productService: ProductService,
                private searchService: SearchService, private registry: RegistryService,
                private customerSearchService: CustomerSearchService, private snackBar: MatSnackBar, private wishlistService: WishlistService) {
    }

    setProductDataset(dataset: ProductDataSet) {
        this.ProductDataSet = dataset;
    }

    sortChanged() {

        if (this.sortBy == this.previousSortBy) {
            return;
        }

        if (this.sortBy == 'newest') {
            this.ProductDataSet.sortBy = 'created_at';
            this.ProductDataSet.sortDir = 'desc';

        }

        if (this.sortBy == 'lowest_price') {
            this.ProductDataSet.sortBy = 'price';
            this.ProductDataSet.sortDir = 'asc';
        }

        if (this.sortBy == 'highest_price') {
            this.ProductDataSet.sortBy = 'price';
            this.ProductDataSet.sortDir = 'desc';
        }

        this.previousSortBy = this.sortBy;
        this.fetchProductDataSet();

    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.ProductDataSet.currentValue == undefined ||
            changes.ProductDataSet.currentValue.params.length == 0) {
            return;
        }
        // if (this.ProductDataSet !== undefined) {
        // this.fetchProductDataSet();

        this.getNextPage(null);

        // You can also use categoryId.previousValue and
        // categoryId.firstChange for comparing old and new values

    }

    getNextPage(event) {
        if (event) {
            event.preventDefault();
        }
        if (this.products.length === 0) {
            return;
        }
        //
        // console.log(this.totalCount);
        // console.log(this.products.length);


        this.isLoading = true;
        this.ProductDataSet.page = this.ProductDataSet.page + 1;
        this.isLoading = true;
        this.page = this.page + 1;
        //     if (!this.previousPage.includes(this.ProductDataSet.page)) {
        if (!(this.products.length >= this.totalCount)) {
            // tslint:disable-next-line:max-line-length
            this.productService.getProductDataSet(this.ProductDataSet.getDataSetParams(this.registry.getWebsiteId()), this.isSearchGrid).subscribe((data: RootObject) => {
                const products_chuck = data.items.map(item => Object.assign(new Product(), item));

                products_chuck.forEach(item => {
                    this.products.push(item);
                });
                console.log(data);
                this.totalCount = data.total_count;
                if (this.totalCount > 0) {
                    this.isLoading = false;
                } else {
                    this.isLoading = true;
                }
                this.flag = false;
                this.previousPage.push(this.ProductDataSet.page);
            });
        }
        //   }

    }

    isButtonHidden() {

        if (((this.products.length >= this.totalCount) && !this.isLoading) || this.products.length == 0) {
            return true;
        }
        return false;
    }

    fetchProductDataSet() {

        if (this.ProductDataSet.params.length == 0) {
            return;
        }

        this.cats_flat =  JSON.parse(localStorage.getItem('cats'));

        if (this.ProductDataSet) {
            this.isLoading = true;
            return this.productService.getProductDataSet(this.ProductDataSet.getDataSetParams(this.registry.getWebsiteId()), this.isSearchGrid).subscribe((data: any) => {
                this.isLoading = false;
                this.products = data.items.map(item => Object.assign(new Product(), item));// Object.assign(new [Product(),data.items);

                this.totalCount = data.total_count;

                this.products.forEach(item => {

                    let arr = item.getCustomAttrByKey('category_ids');
                    arr.forEach(id => {

                        if(id != 2)
                        {
                            if (!this.filter_categories_ids.includes(id)) {

                                this.filter_categories_ids.push(id);
                                this.filter_categories.push( this.cats_flat.filter(v => (v.id == id)));
                                // this.filter_categories.push(this.registry.c)
                            }
                        }

                    })
                })

                console.log(this.filter_categories);
                //
                // console.log(this.totalCount);
                // console.log(this.products.length);
            });
        }


    }

    // Snackbar that opens with success background
    openSuccessSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
            horizontalPosition: 'right',
            panelClass: ['primary-snackbar'],
        });
    }


    ngOnInit(): void {


        if (this.ProductDataSet !== undefined) {
            this.fetchProductDataSet();
        }
        //
        // this.customerSearchService.dataSet$.subscribe((data) => {
        //     this.fetchProductDataSet();
        // });
        // if (this.registry.customer != undefined) {
        //
        //     this.wishlistService.getCustomerWishlist().subscribe(data => {
        //         this.wishList = data;
        //         this.wishlistService.wishList = data;
        //     });
        // }

    }


    ngAfterViewInit() {
        const threshold = 0.2; // how much % of the element is in view
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // run your animation code here
                        this.autoload_pages = this.autoload_pages + 1;
                        if (this.autoload_pages >= this.max_autoload_pages) {
                            this.manual_load = true;
                            return;
                        }
                        this.getNextPage(null);
                        //   observer.disconnect(); // disconnect if you want to stop observing else it will rerun every time its back in view. Just make sure you disconnect in ngOnDestroy instead
                    }
                });
            },
            {threshold}
        );
        observer.observe(this.load_more_btn.nativeElement);
    }

}
